let coCoModule = null
let loadPromise = null

const loadModule = async () => {
   // Ensure we only trigger the import once
   if (!loadPromise) {
      loadPromise = import("@quickline/coco").then(module => {
         coCoModule = module
         console.debug("CoCoModule LOADING DONE", coCoModule)
         return coCoModule
      })
   }
   return loadPromise
}

// Start loading immediately
loadModule()

export const getCoCoModule = async () => {
   if (coCoModule) return coCoModule // Return immediately if already loaded
   return loadModule() // Otherwise, wait for the loading promise
}

export class CoCoError {
   error = null

   constructor(error) {
      this.error = error
		console.debug("CoCoError coco %o, underlying %o", error)
   }
}

 export const wasmToPlainObject = (value, seen = new WeakMap()) => {
	if (value == null || typeof value !== "object") {
	  return value
	}
 
	if (seen.has(value)) {
	  return seen.get(value)
	}
 
	if (Array.isArray(value)) {
	  const result = []
	  seen.set(value, result)
 
	  for (const item of value) {
		 result.push(wasmToPlainObject(item, seen))
	  }
 
	  return result
	}
 
	const isWasmObject = "__wbg_ptr" in value
 
	const result = {}
	seen.set(value, result)
 
	if (isWasmObject) {
	  const proto = Object.getPrototypeOf(value)
 
	  for (const name of Object.getOwnPropertyNames(proto)) {
		 const desc = Object.getOwnPropertyDescriptor(proto, name)
 
		 if (desc?.get) {
			result[name] = wasmToPlainObject(value[name], seen)
		 }
	  }
	} else {
	  for (const [key, val] of Object.entries(value)) {
		 result[key] = wasmToPlainObject(val, seen)
	  }
	}
 
	return result
 }

 export const wasmToPlainObjectNonRecursive = (obj) => {
	const result = {}
 
	const proto = Object.getPrototypeOf(obj)
 
	for (const name of Object.getOwnPropertyNames(proto)) {
	  const desc = Object.getOwnPropertyDescriptor(proto, name)
 
	  if (desc?.get) {
		 result[name] = obj[name]
	  }
	}
 
	return result
 }
